import { Box, Typography } from "@mui/material";
import TermsOfServiceContent from "../components/TermsOfServiceContent";

export const TermsOfServicePage: React.FC = () => {
  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "auto",
        pt: "80px",
        pb: "80px",
        pl: "20px",
        pr: "20px",
      }}
    >
      <Typography variant="h4">Uslovi korišćenja</Typography>
      <TermsOfServiceContent />
    </Box>
  );
};
